import { getTheme, IStyle, mergeStyleSets } from '@fluentui/react'

export const usePRIVATE_STYLES = () => {
  const theme = getTheme();

  const root: IStyle = {
    margin: 0,
    padding: 0,
    display: 'flex',
    flexDirection: 'column',
  };
  const label: IStyle = {
    fontWeight: 600,
    display: 'block',
    padding: '5px 0',
    overflowWrap: 'break-word',
  };
  const requiredLabel: IStyle = {
    ...label,
    '&::after': {
        content: '" *"',
        color: theme.semanticColors.errorIcon,
        paddingRight: 12,
    },
  };

  const inputContainer: IStyle = {
    margin: 0,
    padding: 0,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    maxWidth: 250,
    gap: 10,
    '& > *': {
        flexBasis: 0,
    },
    '& > span': {
      fontSize: 18,
      fontWeight: 400,
    }
  };

  const message: IStyle = { 
    padding: '5px 0',
  };

  const errorMessage: IStyle = { 
    ...message,
    color: theme.semanticColors.errorIcon,
  };

  return mergeStyleSets({
    root,
    inputContainer,
    label,
    requiredLabel,
    message,
    errorMessage,
  });
}